import { Grid, Typography } from "@mui/material";
import React, { useContext } from "react";
import { IMerchantInfoModal } from "../../interfaces/modal";
import { parseCuit } from "../../utils/cuit";
import { UserContext } from "../../contexts/userContext";
import { DEFAULT_COUNTRY, TAX_ID_LABELS } from "../../utils/constants";
import ModalBase from "./ModalBase";

const InfoMerchantModal = ({
  open,
  setOpen,
  integration,
}: IMerchantInfoModal) => {
  const { currentUser } = useContext(UserContext);
  const handleClose = () => setOpen(false);
  const country = currentUser?.entityInfo?.country || DEFAULT_COUNTRY;

  const { name, email, cuit, businessName, ivaSituation, commercialAddress } = integration;

  return (
    <ModalBase open={open} handleClose={handleClose}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography className="m-t-10 f-s-24 text-bold">{name}</Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography className="text-bold">Alias</Typography>
          <Typography>{name}</Typography>
          <Typography className="m-t-10 text-bold">
            {TAX_ID_LABELS[country]}
          </Typography>
          <Typography>{cuit ? parseCuit(cuit, country) : "-"}</Typography>
          <Typography className="m-t-10 text-bold">Razón Social</Typography>
          <Typography>{businessName || "-"}</Typography>
        </Grid>
        <Grid item xs={7}>
          {country === "ARG" && ivaSituation && (
            <>
              <Typography className="text-bold">
                Condición ante el IVA
              </Typography>
              <Typography>{ivaSituation}</Typography>
            </>
          )}
          <Typography className="m-t-10 text-bold">
            Correo electrónico
          </Typography>
          <Typography>{email}</Typography>
          <Typography className="m-t-10 text-bold">
            Domicilio comercial
          </Typography>
          <Typography>{commercialAddress || "-"}</Typography>
        </Grid>
      </Grid>
    </ModalBase>
  );
};

export default InfoMerchantModal;
